import Ext from "Ext";
import SelectorTree from "./at_selector_tree";
import SelectorTreeCheckbox from "./at_selector_tree_checkbox";

/**
 * Abstract selector tree for a simple list of items.
 *
 * Depends on:
 * <code>/js/controls/dateControls/at_selector_tree.js</code>
 * <code>/js/controls/selectorControls/at_selector_tree_checkbox.js</code>
 * <code>/js/message_resources.js</code> with prefix "common"
 */
const SimpleListSelectorTree = Ext.extend(SelectorTree, {

    initComponent: function() {
        SimpleListSelectorTree.superclass.initComponent.call(this);

        this.setInitialSelectionFromCurrent();
    },

    getNameWithStatus: function(item) {
        return this.nodeHelper.getNameWithStatus(item);
    },

    getFullNameWithStatus: function(item) {
        return this.nodeHelper.getFullNameWithStatus(item);
    },

    isActiveItem: function(item) {
        return this.nodeHelper.isActive(item);
    },

    getItemStyleClass: function (item) {
        return this.nodeHelper.getStyleClass( item );
    },

    createNodes: function() {
        var nodes = [];
        Ext.each(this.data, function(item) {
            var node = new SelectorTreeCheckbox({
                                                    item: item,
                                                    label: this.getNameWithStatus(item)
                                                });
            nodes.push(node);
            node.on("change", this.onChange, this);
        }, this);

        return nodes;
    },

    /**
     * @see {AT.SelectorTree}
     */
    resetNodes: function() {
        this.cascade(function(node) {
            if (node.item) {
                node.doSelect(this.propertiesController.isSelectedInit(node.item));
            }
        }, this);
    },

    isSelectionChanged: function(selectHidden) {
        var selectionChanged = false;
        //If function inside cascade returns false, it immediately stop.
        this.cascade(function(node) {
            if (node.item) {
                var wasSelected = this.propertiesController.isSelectedInit(node.item);
                var isSelectedNow = this.propertiesController.isSelected(node.item);
                var wasVisibleButBecomeHidden = !selectHidden && this.propertiesController.isHidden(node.item);
                if ((wasSelected !== isSelectedNow) || (wasSelected && wasVisibleButBecomeHidden)) {
                    selectionChanged = true;
                    return false;
                }
            }
        }, this);
        return selectionChanged;
    },

    /**
     * @see {AT.SelectorTree}
     */
    getSelection: function(selectHidden) {
        var selection = [];
        Ext.each(this.data, function(entry) {
            if (this.propertiesController.isSelected(entry) && (selectHidden || !this.propertiesController.isHidden(entry))) {
                selection.push(entry);
            }
        }, this);
        return selection;
    },

    /**
     * Return the selection with all items
     */
    getAllItems: function()
    {
        var selection = [];
        Ext.each(this.data, function(entry) {
                selection.push(entry);
        }, this);
        return selection;
    },

    /**
     * Replaces stored initial selection with the current one.
     */
    setInitialSelectionFromCurrent: function(newData)
    {
        Ext.each(this.data, function(item) {
            this.propertiesController.setSelectedInit(item, this.propertiesController.isSelected(item));
        }, this);
    },

    /*
     * Deletes all old nodes , create and inserts new nodes
     */
    rebuildTree: function(newData)
    {
        if(!this.data.length==0)
            this.removeAll();

        this.data=newData;

        Ext.each(this.createNodes(), function(node) { this.add(node); }, this);

        this.setInitialSelectionFromCurrent();

    }

});

export default SimpleListSelectorTree;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_simple_list_selector_tree.js